import { type FunctionComponent, useCallback } from "react";
import { graphql, useFragment } from "react-relay";

import { formatDistanceToNow, formatInTimeZone } from "shared/lib/utils";

import type { contentPublishedDateContent$key } from "scmp-app/queries/__generated__/contentPublishedDateContent.graphql";

import { Date } from "./styles";

type Props = {
  className?: string;
  displayMode?: "default" | "relative";
  format?: string;
  reference: contentPublishedDateContent$key;
};

export const ContentPublishedDate: FunctionComponent<Props> = ({
  className,
  displayMode = "default",
  format = "dd MMM, yyyy",
  reference,
}) => {
  const { publishedDate } = useFragment(
    graphql`
      fragment contentPublishedDateContent on Content {
        publishedDate
      }
    `,
    reference,
  );

  const render = useCallback(
    (date: number) => {
      if (displayMode === "relative") {
        return formatDistanceToNow(date);
      }
      return formatInTimeZone(date, format);
    },
    [displayMode, format],
  );

  return publishedDate ? <Date className={className}>{render(publishedDate)}</Date> : null;
};

ContentPublishedDate.displayName = "ContentPublishedDate";
